<template>
  <div class="FansDemandPool">

    <!--  导航  -->
    <FansHeader class="FansHeader"
                nav-color="_black"
                logoColor="_black"
                currNavIdx="0"
    />


    <!--  头部 -->
    <div class="header-wrap ">
      <div class="inner_center">
        <h1 style="opacity: 0;position: fixed;left: -9999px;">
          尊敬的会员您好
          潮国创意精心打造的会员需求池上线啦
        </h1>
        <h2 class="headline">
          <i class="headline1"></i>
          <i class="headline2"></i>
        </h2>
        <div class="subheading">
          VIP用户可以提出来自己个性化的素材需求，根据您提交的需求描述和参考示 <br>
          例，潮国创意来帮你实现满足，宠粉我们是认真的！
        </div>

        <!--  提交素材需求和逛逛会员需求池 -->
        <div class="handle">
          <div class="handle-item submit-pic-demand" @click="writeDemand">
            <div class="txt-name">提交素材需求</div>
            <div class="integral-num">本月可用定制积分：{{ integral  }}</div>

          </div>
          <div class="handle-item watch-demand" @click="watchDemandPool">逛逛会员需求池</div>
        </div>

        <!-- 爱心图 -->
        <i class="heart-pic"></i>
      </div>
    </div>

    <!--  需求池  -->
    <div class="main-wrap" ref="MemberDemandPool">
      <div class="inner_center category-list-box">
        <div class="title">
          会员需求池
          <div class="sub-title">需求池规则
            <div class="sub-title-hover">
              <p> 1、为了让VIP都可以享受宠粉增值服务，每月1号会员账号（多会员身份，按最高级会员来）赠送定制积分，仅用于提设计需求。</p>
              <p class="color-orange">
                个人会员 定制积分500/月 <br>
<!--                商用会员 定制积分1000/月 <br>-->
                企业会员 定制积分无上限（限时体验）<br>
              </p>
              <p>2、当会员提的需求潮国创意可以实现时，会审核通过并进入生产流程。</p>
              <p>3.生产素材会根据难易程度扣除提出者的定制积分。每张作品消耗一次积分，生产多个素材则会累加。积分不足时，无法提新需求。</p>
              <p>4.提出者在会员有效期内可在【我的需求】任务详情页免费下载完成素材，不受素材档位限制。</p>
              <p>5.定制积分每月底清零，不累加、不折现。</p>
            </div>
          </div>
        </div>
        <div class="category-list">
          <div class="category-item"
               v-for="(vo,idx) in FANS.DEMAND_POOL.CATEGORY_LIST"
               :key="vo.id"
               :class="{ 'ON' : vo.sort == params.module }"
               @click="toggleCategory(vo,idx)"
          >
            {{ vo.label }}
          </div>
        </div>

        <!-- 需求轮播 -->
        <div class="scroll-notice">
          <div class="swiper-container"
               v-swiper:mySwiper="swiperOption"
               ref="mySwiper" id="my-handle"
               v-if="scrollNoticeList.length"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide"
                   v-for="(item,index) in scrollNoticeList"
                   :key="index">
                <i class="iconfont icon-notifi"/>
                <span class="message overflow-one">{{ item.message }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="loading">
        <Loading/>
      </template>


      <template v-else>
        <FansDemandPoolList :list="demandList"
                            :ranking-list="rankingList"
                            :type="params.module"
        />

        <DemandPoolListEmpty
          v-if="demandList.length == 0"
          :type="params.module"
          @writeDemand="writeDemand"
        />

        <CtPagination
          v-if="totalPage > 1"
          class="CtPagination"
          :total-page="totalPage"
          :paper-count="5"
          :current-page="params.page"
          @pageClick="handleCurrentChange"
        />
      </template>
    </div>

    <!--  填写需求弹框 -->
    <DemandWriteDialog
      ref="DemandWriteDialog"
      @submitForm="init"
    />

    <!--  非VIP需求拦截弹框 -->
    <ReminderDialog
      ref="ReminderDialog"
      btnTheme="FANS"
      @btnClick="btnClick"
      content-txt="需求池仅限潮国VIP提交"
      btn-txt="购买VIP"
    ></ReminderDialog>

  </div>
</template>

<script>
import mixin from "@/pages/fans/common/mixin";
import _mixin from "@/pages/fans/demand-pool/mixin";
import {fnBrowser, fnFans, fnLogin, fnRouter, fnUser} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {getDemandList, getDemandListByRanking, getDemandUserInfo, getNoticeList} from "@/api/fans/demand-pool";

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

export default {
  name: "FansDemandPool",
  mixins: [mixin, _mixin],
  scrollToTop: false,
  data() {
    return {
      id: this.$route.params.id,
      params: {
        module: 'new',
        page: 1
      },
      totalPage: 0,
      demandList: [],
      loading: true,
      isFixed: false,
      scrollNoticeList: [],
      rankingList: [],
      swiperOption: {
        autoplay: {
          delay: 5000,
          speed: 500,
          disableOninteraction: true
        },
        direction: "vertical",
        initialSlide: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: true, // 在此无效？？？？？
        speed: 500,
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper-container");
            this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex;
          },
        },
      },


      integral: 0
    }
  },
  async asyncData({app}) {

    const {route} = app.context;
    let id = route.params.id;
    let params = fnFans.parseId(id)

    let [
      demandList
    ] = await Promise.all([
      app.$api.getDemandList(params),
    ])
    let {page, pages, list} = demandList.data;
    return {
      params,
      demandList: fnFans.disposeDemandList(list),
      totalPage: pages,
      loading: false,
    }
  },
  mounted() {
    this.init()
    this.getNoticeList();
    this.getDemandListByRanking();
    this.getDemandUserInfo();


    // this.getDemandList();

  },
  methods: {
    init() {
      this.initParseRouterId();
    },

    /* 解析路由 */
    initParseRouterId() {
      let tempId = this.$route.params.id;
      let {module, page} = fnFans.parseId(tempId)
      this.params = Object.assign(this.params, {module, page})
      // this.getDemandList();
    },

    getDemandUserInfo() {
      getDemandUserInfo().then(res => {
        const {status, message, data} = res.data;
        if (status === 200 && data && 'integral' in data) {
          this.integral = data.integral > 998 ? '无上限' : data.integral;
        }
      })
    },

    /* 提需求 */
    async writeDemand() {
      /* 检查是否是会员 */
      let _temFlag = await fnUser.getAccountIsVip();
      if (!fnLogin.checkLogin()) {
        fnLogin.loginIntercept()
        return false
      }
      if (_temFlag) {
        if (this.$refs.DemandWriteDialog) {
          this.$refs.DemandWriteDialog.isShow = true
        } else {
          console.error('检查 填写设计需求组件是否存在')
        }
      } else {
        this.$refs.ReminderDialog.isShow = true
      }
    },
    /* 查看需求池 */
    watchDemandPool() {
      let demandPoolPosition = this.$refs.MemberDemandPool.offsetTop - 48;  // 48是css margin-top -48
      fnBrowser.backToTop(demandPoolPosition)
    },
    toggleCategory(vo, idx) {
      this.watchDemandPool();
      // let path = `${PAGE_PATH.FANS.DEMAND_POOL}/${vo.sort}.html`
      // console.log(this.$route)
      // fnRouter.routerTo(path)
      this.params = {
        module: vo.sort,
        page: 1
      }
      this.getDemandList();
    },

    getDemandList() {
      getDemandList(this.params).then(res => {
        let {page, pages, list} = res.data.data;
        this.demandList = fnFans.disposeDemandList(list);
        this.totalPage = page;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    handleCurrentChange(val) {
      let path = `${PAGE_PATH.FANS.DEMAND_POOL}/${this.params.module}-${val}.html`
      fnRouter.navigationTo(path, '_self');
    },

    getNoticeList() {

      getNoticeList().then(res => {
        let {status, data, message} = res.data;
        if (status == 200) {
          this.scrollNoticeList = data;
        }
      })
    },

    getDemandListByRanking() {
      getDemandListByRanking().then(res => {
        let {status, data, message} = res.data;
        if (status == 200) {

          /* 设置跳转链接 */
          data.forEach(item => {
            item._link_url = CON_COMMON.CON_BASIC.DEMAND_POOL_DETAIL + `/${item.id}.html`
          })
          this.rankingList = data;
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.FansHeader {
  @include Position(1, 5, 50%, 0px);
  transform: translateX(-50%);
  z-index: 99;
}

.FansDemandPool {
  position: relative;


  .header-wrap {
    width: 100%;
    height: 630px;
    background: pink;
    @include BgImage(100%, 630px, 'fans/demand-pool/bg.jpg', 1);

    .headline {
      line-height: 57px;
      border-radius: 2px;
      //padding-top: 150px;
      margin-bottom: 22px;

      display: flex;
      flex-direction: column;

      .headline1 {
        @include BgImage(322px, 52px, 'fans/demand-pool/headline.png');
        margin-bottom: 10px;
      }

      .headline2 {
        @include BgImage(771px, 52px, 'fans/demand-pool/subheading.png');
      }
    }

    .subheading {
      font-size: 16px;
      color: #212121;
      line-height: 28px;
      letter-spacing: 2px;
      margin-bottom: 48px;

    }

    .handle {
      display: flex;

      .handle-item {
        width: 200px;
        height: 54px;
        background: $color-fans;;
        border-radius: 27px;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 1px;
        text-align: center;
        line-height: 52px;
        box-sizing: border-box;
        margin-right: 40px;
        cursor: pointer;

        &:hover {
          background: rgba(255, 109, 124, 1);
        }
      }

      .submit-pic-demand{
        position: relative;
        .txt-name{
          position: relative;
          z-index: 6;
          width: 200px;
          height: 54px;
          background: #ff5d6e;
          border-radius: 27px;
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 1px;
          text-align: center;
          line-height: 52px;
          box-sizing: border-box;
          margin-right: 40px;
          cursor: pointer;
        }

        .integral-num{
          width: 164px;
          height: 28px;
          background: linear-gradient(180deg, #FFF1A4 0%, #FFC04D 100%);
          border-radius: 10px 10px 0px 0px;
          font-size: 12px;
          color: #A45F00;
          line-height: 25px;
          position: absolute;
          left: 18px;
          top: -24px;

        }
      }

      .watch-demand {
        border: 1px solid $color-fans;
        background: #FFFFFF;
        color: $color-fans;

        &:hover {
          background: $color-fans;
          color: #FFFFFF;
        }
      }

    }

    .inner_center {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 150px;
      position: relative;

      .heart-pic {
        @include Position(1, 2, 0, 0px);
        @include BgImage(580px, 574px, 'fans/demand-pool/heart%40big.png');
      }

      @include Screen(1) {

        .headline {
          .headline1 {
            @include BgImage(270px, 46px, 'fans/demand-pool/headline@small.png');
            margin-bottom: 10px;
          }

          .headline2 {
            @include BgImage(650px, 46px, 'fans/demand-pool/subheading@small.png');
          }
        }

        .heart-pic {
          @include Position(1, 2, 0, 0px);
          @include BgImage(484px, 574px, 'fans/demand-pool/heart%40small.png');
        }
      }
    }
  }


  .main-wrap {
    margin-top: -48px;
    position: relative;
    z-index: 5;

    .category-list-box {
      position: relative;

      &.Fixed {
        position: fixed;
        top: 80px;
        left: 0;
        z-index: 99;
      }
    }

    .placeholder {
      height: 70px;
    }

    .title {
      height: 32px;
      font-size: 24px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 32px;
      letter-spacing: 3px;
      margin-bottom: 20px;
      display: flex;

      .sub-title {
        width: 80px;
        height: 28px;
        background: #FFFFFF;
        border-radius: 14px;
        border: 1px solid transparent;
        font-size: 12px;
        line-height: 28px;
        text-align: center;
        color: #596088;
        margin-left: 12px;
        position: relative;
        cursor: pointer;


        &:hover {
          border: 1px solid #FF5D6E;
          color: #FF5D6E;
          &:after {
            content: '';
            display: inline-block;
            width: 10px;
            height: 100%;
            background: transparent;
            position: absolute;
            right: -10px;
            bottom: 0;
          }

          .sub-title-hover {
            display: block;
          }
        }

        .sub-title-hover {
          width: 340px;
          //height: 265px;
          background: #FFFFFF;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          position: absolute;
          right: -347px;
          bottom: 0;
          text-align: left;
          padding: 15px 14px 10px;
          box-sizing: border-box;
          display: none;

          &:after {
            content: '';
            width: 10px;
            height: 10px;
            background-color: #FFFFFF;
            transform: rotate(135deg);
            position: absolute;
            left: -4px;
            bottom: 10px;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
          }

          &:before {
            content: '';
            width: 10px;
            height: 90%;
            position: absolute;
            left: 0;
            bottom: 3px;
            background: #FFFFFF;
            z-index: 5;
            border-radius: 8px;
          }


          p {
            font-size: 12px;
            color: #424866;
            line-height: 18px;
            margin-bottom: 4px;
          }

          .color-orange {
            color: #D37A00;
          }
        }
      }
    }

    .category-list {
      display: flex;
      align-items: center;
      margin-bottom: 36px;

      .category-item {
        height: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #424866;
        line-height: 20px;
        margin-right: 28px;
        cursor: pointer;

        &.ON {
          color: $color-fans;
        }
      }
    }

    .scroll-notice {
      //width: 322px;
      padding-right: 16px;
      height: 38px;
      border-radius: 21px;
      @include Position(1, 2, 0, 32px);
      background: linear-gradient(268deg, #FDF0F6 0%, #FDF5F1 100%);
      cursor: pointer;

      .swiper-container {
        height: 100%;

        .swiper-slide {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #596080;

          .icon-notifi {
            font-size: 14px;
            margin: 0 14px 0 16px;
          }

          .message {
            //max-width: 260px;
          }
        }
      }
    }

  }
}

</style>
